import type React from 'react'

import css from './styles.module.scss'

export const UsageSkeleton: React.FC = () => (
  <>
    <div className={css.card}>
      <div data-skeleton-animation className={css.sk_title} />

      <div className={css.grid}>
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className={css.column}>
            <div data-skeleton-animation className={css.sk_label} />
            <div data-skeleton-animation className={css.sk_value} />
            <div data-skeleton-animation className={css.sk_bar} />
            <div data-skeleton-animation className={css.sk_label} />
          </div>
        ))}
      </div>
    </div>

    <div className={css.card}>
      <div data-skeleton-animation className={css.sk_title} />
      <div data-skeleton-animation className={css.sk_chart} />
    </div>
  </>
)
